import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const ADD_EVENT_SUCCESS = "ADD_EVENT_SUCCESS";
export const ADD_EVENT_ERROR = "ADD_EVENT_ERROR";

// Thunk Action Creator
export const addEventAction = createAsyncThunk(
    "api/Calendar/addEvent",
    async (json, { dispatch }) => {

        try {
            if (!json.title || json.title.trim() === '') {
                console.log('Event title is empty, not saving');
                return;
            }
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/addEvent`,
                {
                    Type: json.type,
                    CalendarId: json.calendarId,
                    TaskId: json.taskId,
                    Color: json.color,
                    Title: json.title,
                    Start: json.start,
                    End: json.end, 
                    AllDay: json.allDay,
                    TimeZone: timeZone
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            if (response.status === 200) {
                if (response.data === '') {
                    throw new Error("Problem adding an event. Logging the user out");
                } else {
                    dispatch({
                        type: ADD_EVENT_SUCCESS,
                        payload: response.data,
                    });
                }
            }
        }
        catch (error) {
            dispatch({ type: ADD_EVENT_ERROR, payload: error });
            //await signOut();
        }
    }
);
